import { Listbox, Transition } from '@headlessui/react';
import Down from 'assets/icons/Down';
import Up from 'assets/icons/Up';
import useTranslation from 'common/hooks/useTranslation';
import { cn } from 'common/utils';
import { useField } from 'formik';
import React, { Fragment } from 'react';

// Define work type options
const workTypeOptions = [
  { label: 'ONSITE', value: 'ONSITE' },
  { label: 'REMOTE', value: 'REMOTE' },
  { label: 'HYBRID', value: 'HYBRID' },
];

const WorkSelect = ({ name, label, isDisabled }) => {
  const [field, , helpers] = useField(name);
  const { t } = useTranslation('offers\\new');

  return (
    <Listbox
      value={field.value}
      onChange={(value) => {
        helpers.setValue(value);
      }}
      disabled={isDisabled}
    >
      {({ open }) => (
        <div className='relative'>
          <Listbox.Label className='uppercase text-xs font-semibold text-weldon-blue'>
            {label}
          </Listbox.Label>
          <Listbox.Button
            className={cn(
              'rounded-md px-4 py-2 w-full flex justify-between items-center mt-1.5',
              'text-dark-blue border border-dark-blue outline-dark-blue',
              'disabled:border-soft-blue disabled:text-soft-blue disabled:bg-white disabled:cursor-not-allowed',
            )}
          >
            <div className='flex items-center gap-2.5 py-1'>
              {t(`workType.${field.value}`) || field.value}
            </div>
            {open ? <Up /> : <Down />}
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave='transition ease-in duration-100'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <Listbox.Options
              className={cn(
                'mt-1 w-full rounded-md bg-white text-base shadow-lg',
                'ring-1 ring-black ring-opacity-5 focus:outline-none',
                'max-h-[180px] absolute',
                'overflow-y-auto scrollbar scrollbar-w-1',
                'scrollbar-thumb-vibrant-orange scrollbar-thumb-rounded',
                'scrollbar-track-rounded z-50',
              )}
            >
              {workTypeOptions.map((option) => (
                <Listbox.Option
                  key={option.value}
                  className={({ active }) =>
                    cn(
                      'flex w-full items-center',
                      'px-4 py-4 text-sm gap-2.5',
                      'select-none rounded-t-md',
                      {
                        'bg-vibrant-orange bg-opacity-10': active,
                      },
                    )
                  }
                  value={option.value}
                >
                  <div className='flex items-center gap-2.5 py-1'>
                    {t(`workType.${option.value}`) || option.label}
                  </div>
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
};

export default WorkSelect;
